import { Component, input } from '@angular/core';

@Component({
  selector: 'gs-image-cell',
  template: `@if (src()) {
    <span class="gs-image-cell">
      <img class="gs-image-cell-img" [src]="src()" alt="" />
      @if (previewOnHover()) {
        <img class="gs-image-cell-preview" [src]="src()" alt="" />
      }
    </span>
  }`,
  styles: [
    `
      .gs-image-cell {
        display: inline-block;
      }

      .gs-image-cell-img {
        display: block;
        max-height: 40px;
        max-width: 40px;
      }

      .gs-image-cell-preview {
        display: none;
      }

      .gs-image-cell:hover .gs-image-cell-preview {
        display: block;
        position: fixed;
        z-index: 500;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: white;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
        border-radius: 4px;
        padding: 10px;
        max-width: 500px;
        max-height: 500px;
        object-fit: contain;
      }
    `,
  ],
})
export class GsImageCellComponent {
  readonly src = input<string | null>(null);
  readonly previewOnHover = input<boolean>(false);
}
